import axios from 'axios';
import Cookies from 'js-cookie';
import { BACKEND_URL } from './authService';

export interface ExportParams {
    id: number;
    format?: string;
}

export const exportCartPdf = async (lang: string = 'cs'): Promise<Blob> => {
    const token = Cookies.get('CatermatAuthToken');
    const params: any = {};
    if (lang) {
        params.lang = lang;
    }

    const response = await axios.get(`${BACKEND_URL}/eshop/carts/export`, {
        headers: { Authorization: `Bearer ${token}` },
        params,
        responseType: 'blob',
    });

    return response.data as Blob;
};

